import { render, staticRenderFns } from "./SmallNavLeft.vue?vue&type=template&id=901b81b6&scoped=true"
import script from "./SmallNavLeft.vue?vue&type=script&setup=true&lang=ts"
export * from "./SmallNavLeft.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SmallNavLeft.vue?vue&type=style&index=0&id=901b81b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901b81b6",
  null
  
)

export default component.exports